import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FeaturedProperties() {
  return <section id="listings" className="py-20 md:py-32 bg-brand-cream" data-id="element-38">
      <div className="container mx-auto px-4 md:px-6" data-id="element-39">
        <div className="max-w-3xl mx-auto text-center" data-id="element-40">
          <span className="text-brand-copper tracking-[0.2em] text-sm font-semibold uppercase mb-4 block" data-id="element-41">
            Featured Listings
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-6" data-id="element-42">
            Now on the market
          </h2>
          <p className="text-brand-taupe text-lg md:text-xl font-light mb-10 leading-relaxed" data-id="element-43">
            Browse active listings across Broomfield, Denver, and the Front
            Range.
          </p>
          <a href="#" className="inline-flex items-center justify-center gap-2 bg-brand-copper hover:bg-brand-copper/90 text-white px-10 py-4 rounded-lg font-medium transition-colors text-lg" data-id="element-44">
            View All Listings
            <ArrowRight size={18} data-id="element-45" />
          </a>
        </div>
      </div>
    </section>;
}